import { useEffect } from 'react'
import { useFeatureFlagsRuntime } from './FeatureFlagsRuntimeProvider'
import { getFeatureFlagProvider } from './providersByFlag'

const stableSerialize = value => {
  if (Array.isArray(value)) {
    return `[${value.map(stableSerialize).join(',')}]`
  }

  if (value && typeof value === 'object') {
    return `{${Object.keys(value)
      .sort()
      .map(key => `${JSON.stringify(key)}:${stableSerialize(value[key])}`)
      .join(',')}}`
  }

  return JSON.stringify(value)
}

export const useFeatureFlag = (flagName, options = {}) => {
  const { getFlagValue, loadFlagValue } = useFeatureFlagsRuntime()
  const provider = options.provider || getFeatureFlagProvider(flagName)
  const contextKey = stableSerialize(options.context || {})

  useEffect(() => {
    if (provider === 'backend') {
      loadFlagValue(flagName, options)
    }
  }, [contextKey, flagName, loadFlagValue, provider])

  return getFlagValue(flagName, options)
}

export const useFlag = (flagName, options = {}) =>
  useFeatureFlag(flagName, options)
